import React from 'react';
import Edit from 'containers/rest/Edit';
import Form from '../components/Form';

const CustomersEdit = (props) => (
  <Edit {...props} resource="customers">
    <Form />
  </Edit>
);

export default CustomersEdit;
